module.exports = __webpack_public_path__ + "static/media/football-header.48b6685a.jpg";